import React from "react";
import { Navigate } from "react-router-dom";

class Sponsor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shouldRedirect: false,
    };
  }

  onNextClick = (event) => {
    event.preventDefault();
    this.setState({ shouldRedirect: true });
  }

  render() {
    return (
      <div className="container mx-auto mt-5 p-3">
        {this.state.shouldRedirect && (
          <Navigate replace to="/thank-you" />
        )}
        <p className="title is-4 has-text-centered">Sponsored by Vortech</p>

        <figure className="image is-block">
          <img
            style={{ margin: "0 auto", "max-width": "400px" }}
            src="/VortechLogo2.jpg"
            alt="Vortech LTD Logo"
          />
        </figure>
        <p className="subtitle is-4 has-text-centered mt-4">
          Thank you to Vortech for allowing us to provide this service at no
          cost to you.
        </p>
        <div className="is-block">
          <button
            onClick={this.onNextClick}
            className="button is-primary is-pulled-right is-block mb-4 mt-4"
          >
            Next
          </button>
        </div>
      </div>
    );
  }
}

export default Sponsor;
